/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDirectMessageResponse } from './IDirectMessageResponse';
import {
    IDirectMessageResponseFromJSON,
    IDirectMessageResponseFromJSONTyped,
    IDirectMessageResponseToJSON,
    IDirectMessageResponseToJSONTyped,
} from './IDirectMessageResponse';

/**
 * 
 * @export
 * @interface GetDmMessagesResponse
 */
export interface GetDmMessagesResponse {
    /**
     * 
     * @type {Array<IDirectMessageResponse>}
     * @memberof GetDmMessagesResponse
     */
    messages: Array<IDirectMessageResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof GetDmMessagesResponse
     */
    hasMore?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetDmMessagesResponse
     */
    oldestTimestamp?: number;
}

/**
 * Check if a given object implements the GetDmMessagesResponse interface.
 */
export function instanceOfGetDmMessagesResponse(value: object): value is GetDmMessagesResponse {
    if (!('messages' in value) || value['messages'] === undefined) return false;
    return true;
}

export function GetDmMessagesResponseFromJSON(json: any): GetDmMessagesResponse {
    return GetDmMessagesResponseFromJSONTyped(json, false);
}

export function GetDmMessagesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDmMessagesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'messages': ((json['messages'] as Array<any>).map(IDirectMessageResponseFromJSON)),
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
        'oldestTimestamp': json['oldestTimestamp'] == null ? undefined : json['oldestTimestamp'],
    };
}

export function GetDmMessagesResponseToJSON(json: any): GetDmMessagesResponse {
    return GetDmMessagesResponseToJSONTyped(json, false);
}

export function GetDmMessagesResponseToJSONTyped(value?: GetDmMessagesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'messages': ((value['messages'] as Array<any>).map(IDirectMessageResponseToJSON)),
        'hasMore': value['hasMore'],
        'oldestTimestamp': value['oldestTimestamp'],
    };
}

